import { SideMenuI } from '../../shared/interfaces/side-menu.interface';

export const SUPPORTS_SIDE_MENU_ITEMS: SideMenuI[] = [
  {
    title: 'Support',
    route: 'support',
    translationPath: 'sideMenu.support',
    activeIcon: 'svgs/side-menu/active-merchant-overview.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchant-overview.svg',
    roles: [],
  },
];
